import { render, staticRenderFns } from "./AddRentalClothesCustomer.vue?vue&type=template&id=7f494c98&"
import script from "./AddRentalClothesCustomer.vue?vue&type=script&lang=js&"
export * from "./AddRentalClothesCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports